import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-search-account-type-master',
  templateUrl: './search-account-type-master.component.html',
  styleUrls: ['./search-account-type-master.component.scss']
})
export class SearchAccountTypeMasterComponent implements OnInit {

  searchAccountmaster:any;
  arraylist:any=[];
  orignaldata:any=[];
  constructor(public dialog: MatDialog,public dialogRef: MatDialogRef<SearchAccountTypeMasterComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { 
    this.orignaldata = data
    this.arraylist =data;
  }

  ngOnInit(): void {}

   onAtypeSearch(searchTerm: string) {
  const lowerSearchTerm = searchTerm.toLowerCase();

  if (!lowerSearchTerm) {
    this.arraylist = this.orignaldata;
    return;
  }
  const exactMatches = this.arraylist
    .map((item, index) => ({ ...item, _originalIndex: index }))
    .filter(item =>
      (item.accountType && item.accountType.toLowerCase() === lowerSearchTerm)
    );

  const partialMatches = this.arraylist
    .map((item, index) => ({ ...item, _originalIndex: index }))
    .filter(item =>
      (
        (item.accountType && item.accountType.toLowerCase().includes(lowerSearchTerm))
      ) &&
      !exactMatches.find(m => m._originalIndex === item._originalIndex)
    );
  this.arraylist = [...exactMatches, ...partialMatches];
}
  closedialog() {
    this.dialogRef.close(0);
  }
  selectRowdata(rowdata){
    this.dialogRef.close(rowdata);
  }

}
